import { useEffect, useState } from 'react';

const useCountdownTimer = ({ time }: PropType) => {
   const [timeLeft, setTimeLeft] = useState(time);

   useEffect(() => {
      if (timeLeft <= 0) return;

      const interval = setInterval(() => {
         setTimeLeft(prev => prev - 1);
      }, 1000);

      return () => clearInterval(interval);
   }, [timeLeft]);

   const formatTime = (seconds: number) => {
      const m = Math.floor(seconds / 60);
      const s = seconds % 60;
      return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
   };

   return { timeLeft: formatTime(timeLeft), resetTimer: (t?: number) => setTimeLeft(t || time) };
};

export default useCountdownTimer;

type PropType = {
   time: number;
};
